import { useLocaleStore } from './localeStore'
import { useQuotationsStore } from './quotationsStore'

function clearAllStores() {
  localStorage.clear()
}

export { useLocaleStore, useQuotationsStore, clearAllStores }
